import { ValidationProvider, extend, localize, setInteractionMode } from 'vee-validate';
import { required, email, min, numeric } from 'vee-validate/dist/rules';
import en from 'vee-validate/dist/locale/en.json';
import i18n from '@/i18n';

extend('required', required);
extend('email', email);
extend('min', min);
extend('numeric', numeric);

const requireContext = require.context('./rules', false, /.*\.js$/);

requireContext
    .keys()
    .map(file => [file.replace(/(^.\/)|(\.js$)/g, ''), requireContext(file)])
    .forEach(([name, rule]) => {
        extend(name, rule.default);
    });

localize({
    en: {
        messages: { ...en.messages, ...i18n.t('rules') },
    },
});

localize('en');

setInteractionMode('custom', () => {
    return {
        on: ['input', 'change'],
    };
});

export default ValidationProvider;
